import { routeConstants } from "shared/constants/route"
import Home from './Home'

const HomeRoute = {
    path: routeConstants.HOME.route,
    component: Home
}

export default HomeRoute